import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { EXPENSES_SUMMARY } from 'api/query-keys.ts';
import type { TExpensesTotalRes } from 'api/swagger';
import type { IExpensesFilter } from 'shared/stores/use-expenses-filters.ts';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs.ts';

interface IParams {
  search?: string;
  filters?: IExpensesFilter;
}

export const useGetExpensesSummary = (params?: IParams) => {
  const { search, filters } = params || {};

  const qs = new URLSearchParams();
  if (search) qs.set('filter[search]', search);
  if (filters) setFiltersToQs<IExpensesFilter>(qs, filters);

  return useQuery<TExpensesTotalRes>({
    queryKey: [EXPENSES_SUMMARY, qs.toString()],
    queryFn: async () => {
      const { data } = await http.get<TExpensesTotalRes>(`/v1/expenses/total?${qs.toString()}`);

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 10,
    cacheTime: 10,
  });
};
